import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import {
  getProfile,
  getProfileStreakStats,
  getStreakDays,
  getTopConsumedCategories,
  getUser,
} from "./thunks";
import { ReaderStatisticsState } from "./types";

export const name = "readerStatistics";

const initialState: ReaderStatisticsState = {
  profile: {
    data: null,
    status: "idle",
  },
  user: {
    data: null,
    status: "idle",
  },
  topConsumedCategories: {
    data: [],
    status: "idle",
  },
  profileStreakStats: {
    data: null,
    status: "idle",
  },
  streakDays: {
    data: [],
    status: "idle",
  },
};

export const getProfileAsync = createAsyncThunk(
  name + "/getProfile",
  getProfile
);

export const getUserAsync = createAsyncThunk(name + "/getUser", getUser);

export const getTopConsumedCategoriesAsync = createAsyncThunk(
  name + "/getTopConsumedCategories",
  getTopConsumedCategories
);

export const getProfileStreakStatsAsync = createAsyncThunk(
  name + "/getProfileStreakStats",
  getProfileStreakStats
);

export const getStreakDaysAsync = createAsyncThunk(
  name + "/getStreakDays",
  getStreakDays
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfileAsync.pending, (state) => {
        state.profile.status = "loading";
      })
      .addCase(getProfileAsync.fulfilled, (state, action) => {
        state.profile = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getProfileAsync.rejected, (state) => {
        state.profile.status = "failed";
      })
      .addCase(getUserAsync.pending, (state) => {
        state.user.status = "loading";
      })
      .addCase(getUserAsync.fulfilled, (state, action) => {
        state.user = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getUserAsync.rejected, (state) => {
        state.user.status = "failed";
      })
      .addCase(getTopConsumedCategoriesAsync.pending, (state) => {
        state.topConsumedCategories.status = "loading";
      })
      .addCase(getTopConsumedCategoriesAsync.fulfilled, (state, action) => {
        state.topConsumedCategories = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getTopConsumedCategoriesAsync.rejected, (state) => {
        state.topConsumedCategories.status = "failed";
      })
      .addCase(getProfileStreakStatsAsync.pending, (state) => {
        state.profileStreakStats.status = "loading";
      })
      .addCase(getProfileStreakStatsAsync.fulfilled, (state, action) => {
        state.profileStreakStats = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getProfileStreakStatsAsync.rejected, (state) => {
        state.profileStreakStats.status = "failed";
      })
      .addCase(getStreakDaysAsync.pending, (state) => {
        state.streakDays.status = "loading";
      })
      .addCase(getStreakDaysAsync.fulfilled, (state, action) => {
        state.streakDays = {
          data: action.payload,
          status: "idle",
        };
      })
      .addCase(getStreakDaysAsync.rejected, (state) => {
        state.streakDays.status = "failed";
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
